import { OR, PACU, PRE_OP, WAITING_ROOM } from '../room/enums';

export const roomTypeToProcedureColumn = {
  [WAITING_ROOM]: 'expectedWRDuration',
  [PRE_OP]: 'expectedPreOpDuration',
  [OR]: 'expectedDuration',
  [PACU]: 'expectedPacuDuration',
};
